import React, { useState, useEffect } from 'react';
import API_BASE_URL from './config';

const OnboardingStep3 = ({ formData, updateFormData, onNext, onBack }) => {
    const [selectedState, setSelectedState] = useState('');
    const [availableCities, setAvailableCities] = useState([]);
    const [selectedCities, setSelectedCities] = useState(formData.city_ids || []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const states = ['AZ', 'CA', 'CO', 'NM', 'NV', 'TX', 'UT']; // Common states

    useEffect(() => {
        // Load cities for selected state
        if (selectedState) {
            loadCitiesForState(selectedState);
        }
    }, [selectedState]);

    const loadCitiesForState = async (state) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `${API_BASE_URL}/api/cities/by-state?state=${state}`,
                { credentials: 'include' }
            );

            if (!response.ok) {
                throw new Error('Failed to load cities');
            }

            const data = await response.json();
            setAvailableCities(data.cities || []);
        } catch (err) {
            setError(err.message || 'Failed to load cities');
        } finally {
            setLoading(false);
        }
    };

    const handleStateChange = (state) => {
        setSelectedState(state);
    };

    const handleSelectAllCities = () => {
        const allCityIds = availableCities.map((c) => c.id);
        setSelectedCities(allCityIds);
        updateFormData({ city_ids: allCityIds });
    };

    const handleDeselectAllCities = () => {
        setSelectedCities([]);
        updateFormData({ city_ids: [] });
    };

    const handleCityToggle = (cityId) => {
        const updated = selectedCities.includes(cityId)
            ? selectedCities.filter((id) => id !== cityId)
            : [...selectedCities, cityId];
        setSelectedCities(updated);
        updateFormData({ city_ids: updated });
    };

    const canProceed = selectedCities.length > 0;

    return (
        <div className="wizard-step">
            <div className="step-header">
                <h2>Select Locations</h2>
                <p>Choose the cities and regions where you work</p>
            </div>

            <div className="form-group">
                <label>
                    Select State <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                    value={selectedState}
                    onChange={(e) => handleStateChange(e.target.value)}
                    style={{ width: '200px' }}
                >
                    <option value="">-- Choose a state --</option>
                    {states.map((state) => (
                        <option key={state} value={state}>
                            {state}
                        </option>
                    ))}
                </select>
            </div>

            {loading && <p>Loading cities...</p>}

            {error && <div className="error-message">{error}</div>}

            {availableCities.length > 0 && (
                <div className="form-group">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <label>
                            Select Cities <span style={{ color: 'red' }}>*</span> ({selectedCities.length} selected)
                        </label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                onClick={handleSelectAllCities}
                                style={{
                                    padding: '6px 12px',
                                    background: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                            >
                                Select All
                            </button>
                            <button
                                onClick={handleDeselectAllCities}
                                style={{
                                    padding: '6px 12px',
                                    background: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                            >
                                Deselect All
                            </button>
                        </div>
                    </div>

                    <div
                        style={{
                            maxHeight: '400px',
                            overflowY: 'auto',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '10px'
                        }}
                    >
                        <div className="checkbox-group">
                            {availableCities.map((city) => (
                                <label key={city.id} style={{ padding: '5px 0' }}>
                                    <input
                                        type="checkbox"
                                        checked={selectedCities.includes(city.id)}
                                        onChange={() => handleCityToggle(city.id)}
                                    />
                                    {city.name}
                                </label>
                            ))}
                        </div>
                    </div>

                    {selectedCities.length === 0 && (
                        <div className="error-message">Please select at least one city</div>
                    )}
                </div>
            )}

            {!selectedState && (
                <p style={{ color: '#999', fontStyle: 'italic' }}>
                    Please select a state to view available cities
                </p>
            )}

            <div className="step-footer">
                <button onClick={onBack} className="btn-back">
                    ← Back
                </button>
                <button onClick={onNext} className="btn-next" disabled={!canProceed}>
                    Next →
                </button>
            </div>
        </div>
    );
};

export default OnboardingStep3;

